import axios from 'axios'

const getters = {
    getLocationCategories: (state) => {
        return state.categories.filter((item) => {
            return item.type === 'bf2f1ea1-dd71-4698-a18e-6046d82d4758'
        })
    },
    getEventCategories: (state) => {
        return state.categories.filter((item) => {
            return item.type === '949e29a5-bbb5-4005-84c2-495d58602699'
        })
    },
    getEvents: (state) => {
        return state.data
    },
    getLocationCategory: (state) => (id) => {
        return state.categories.find((location) => {
            return location.id === id
        })
    },
    getEventCategory: (state) => (id) => {
        return state.categories.find((event) => {
            return event.id === id
        })
    },
    getUserFilter: (state) => {
        return state.userFilter
    },
    getCurrentEventCategory: (state) => {
        return state.userFilter.event
    },
    getCurrentLocationCategory: (state) => {
        return state.userFilter.location
    },
}

const actions = {
    async updateDefaultLocationFilter({ commit }, locationKey) {
        if (!locationKey) {
            return
        }

        try {
            const response = await axios.get(`/api/categories/${locationKey}`)
            commit('SET_HAS_DEFAULT_LOCATION_FILTER', true)
            commit('SET_LOCATION_FILTER', response.data)
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('🚨', `'data-location-id' could not be found`, e)
        }
    },
    async updateDefaultEventFilter({ commit }, typeKey) {
        if (!typeKey) {
            return
        }

        try {
            const response = await axios.get(`/api/categories/${typeKey}`)
            commit('SET_HAS_DEFAULT_EVENT_FILTER', true)
            commit('SET_EVENT_FILTER', response.data)
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('🚨', `'data-types-id' could not be found`, e)
        }
    },

    async updateDefaultMaxMonthsFilter({ commit }, months) {
        if (!months) {
            return
        }
        commit('SET_MONTHS_FILTER', months)
    },

    async getCategories({ commit }) {
        const response = await axios.get('/api/categories')
        commit('SET_CATEGORIES_DATA', response.data.data)
    },

    async getEventData({ commit, state }) {
        const params = {}

        if (state.userFilter.search) {
            params['search'] = state.userFilter.search
        }

        if (state.userFilter.event && state.userFilter.event.id) {
            params['event_id'] = state.userFilter.event.id
        }

        if (state.userFilter.location && state.userFilter.location.id) {
            params['location_id'] = state.userFilter.location.id
        }

        if (state.userFilter.months >= 0) {
            params['months'] = state.userFilter.months
        }

        const response = await axios.get('/api/events', { params })
        commit('SET_EVENT_DATA', response.data)
    },
    updateSearchFilter: ({ commit, dispatch }, payload) => {
        commit('SET_SEARCH_FILTER', payload)
        dispatch('getEventData')
    },
    updateEventFilter: ({ commit, dispatch }, payload) => {
        commit('SET_EVENT_FILTER', payload)
        dispatch('getEventData')
    },
    updateLocationFilter: ({ commit, dispatch }, payload) => {
        commit('SET_LOCATION_FILTER', payload)
        dispatch('getEventData')
    },
}

const mutations = {
    SET_EVENT_DATA: (state, payload) => {
        state.data = [...payload.data]
    },
    SET_SEARCH_FILTER: (state, payload) => {
        state.userFilter = {
            ...state.userFilter,
            search: payload,
        }
    },
    SET_EVENT_FILTER: (state, payload) => {
        state.userFilter = {
            ...state.userFilter,
            event: { ...payload },
        }
    },
    SET_LOCATION_FILTER: (state, payload) => {
        state.userFilter = {
            ...state.userFilter,
            location: { ...payload },
        }
    },
    SET_MONTHS_FILTER: (state, payload) => {
        state.userFilter = {
            ...state.userFilter,
            months: payload,
        }
    },
    SET_HAS_DEFAULT_LOCATION_FILTER: (state, payload) => {
        state.defaultFilter = {
            ...state.defaultFilter,
            hasDefaultLocationCategoryFilter: payload,
        }
    },
    SET_HAS_DEFAULT_EVENT_FILTER: (state, payload) => {
        state.defaultFilter = {
            ...state.defaultFilter,
            hasDefaultEventCategoryFilter: payload,
        }
    },
    SET_CATEGORIES_DATA: (state, payload) => {
        state.categories = [...payload]
    },
}

export const defaultCategoryFilterItem = {
    id: null,
    label: '<hr class="my-2.5 w-8 border rounded-full">',
}

export default {
    namespaced: true,
    state: () => ({
        data: [],
        categories: [],
        userFilter: {
            search: '',
            location: defaultCategoryFilterItem,
            event: defaultCategoryFilterItem,
            months: 0,
        },
        defaultFilter: {
            hasDefaultLocationCategoryFilter: false,
            hasDefaultEventCategoryFilter: false,
        },
    }),
    getters,
    actions,
    mutations,
}
